module.exports = __webpack_public_path__ + "img/[害羞].15ee3e69.svg";